module.exports = __webpack_public_path__ + "img/DW365-169.18f893e1.jpg";